export const REPORT_LABEL = 'Arbeitsbericht';
export const DATE_LABEL = 'Datum';
export const LOCATION_LABEL = 'Ort';
